<script setup>
import { scroll } from "@/core/helpers/scrollTo.js";
import { useRoute, useRouter } from "vue-router";
import { ref } from "vue";

const route = useRoute();
const router = useRouter();
const menuOpen = ref(false);

const scrollTo = (id, routeName) => {
  menuOpen.value = false; // закрываем меню при переходе
  if (route.name === routeName) {
    scroll(id);
  } else {
    router.push({ name: "home" }).then(() => scroll(id, 300));
  }
};
</script>

<template>
  <div class="hero">
    <div class="hero__wrapper">
      <img src="@images/hero-bg.png" alt="" />
      <div class="hero__wrapper__content">
        <div class="hero__wrapper__content-title">
          <h1>
            Seamless Payments
            for a Borderless World
          </h1>
        </div>
        <div class="hero__wrapper__content-description">
          <p>
            Empower your business with fast, secure, and global payment
            processing — all in one powerful platform.
          </p>
          <button @click="scrollTo('about', 'home')">
            Get Started
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
h1 {
  color: #46302e;
  font-family: "Libre Caslon Text", sans-serif;
  font-size: 48px;
  font-style: italic;
  font-weight: 500;
  line-height: normal;
  max-width: 600px;
}

p {
  color: #46302e;
  text-align: justify;
  font-family: "Didact Gothic", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  max-width: 550px;
}

button {
  border-radius: 10px;
  background: #fff;
  padding: 10px 75px;
  width: fit-content;
  color: #46302e;
  text-align: justify;
  font-family: Georama, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    color: #cda57d;
    background-color: black;
  }
}

.hero {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: -35px;

  &__wrapper {
    position: relative;
    width: 100%;
    max-width: 1440px;

    img {
      width: 100%;
      height: auto;
      display: block;
      border-radius: 0;
      object-fit: cover;
    }

    &__content {
      position: absolute;
      bottom: 60px;
      width: 100%;
      display: flex;
      gap: 200px;
      justify-content: space-around;
      align-items: flex-end;
      padding-inline: 60px;

      &-description {
        display: flex;
        flex-direction: column;
        gap: 15px;
      }
    }
  }

  /* ---------- адаптив ---------- */

  @media (max-width: 1200px) {
    .hero__wrapper__content {
      gap: 100px;
      padding-inline: 40px;

      h1 {
        font-size: 42px;
      }

      p {
        font-size: 18px;
      }
    }
  }

  @media (max-width: 992px) {
    .hero__wrapper__content {
      flex-direction: column;
      align-items: flex-start;
      gap: 30px;
      bottom: 40px;
      padding-inline: 40px;

      &-description {
        align-items: flex-start;
      }
    }

    h1 {
      font-size: 36px;
      max-width: 100%;
    }

    p {
      font-size: 18px;
      text-align: left;
    }

    button {
      padding: 10px 60px;
      font-size: 16px;
    }
  }

  @media (max-width: 768px){

    .hero{
      margin-top: 0 !important;
      padding-top: 100px;
    }

    .hero__wrapper__content {
      align-items: center;
      text-align: center;
      padding-inline: 20px;
      bottom: 30px;

      &-description {
        align-items: center;
      }
    }

    img {
      height: 280px;
    }

    h1 {
      font-size: 30px;
    }

    p {
      font-size: 16px;
      max-width: 90%;
    }

    button {
      font-size: 16px;
      padding: 8px 50px;
    }
  }

  @media (max-width: 480px) {
    .hero__wrapper__content {
      bottom: 20px;
      gap: 25px;

      h1 {
        font-size: 26px;
      }

      p {
        font-size: 15px;
      }

      button {
        font-size: 14px;
        padding: 8px 40px;
      }
    }
  }
}
</style>
